do ->

    angular
        .module 'fundersclub.introductionRequests', [
            'fundersclub.models'
        ]
